import { render, staticRenderFns } from "./PositionFormDetails.vue?vue&type=template&id=e499f7ac&"
import script from "./PositionFormDetails.vue?vue&type=script&lang=js&"
export * from "./PositionFormDetails.vue?vue&type=script&lang=js&"
import style0 from "./PositionFormDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports